export default {
  loadTypes: {
    furniture: 'Moving',
    cargo: 'Intercity load',
    postalPostage: 'Postal postage',
    delivery: 'Delivery',
    pickup: 'Urban load (pickup)',
    material: 'Material',
    trash: 'Trash',
    freight: 'freight'
  },
  pending: 'Pending',
  accepted: 'Accepted',
  current: 'Current',
  completed: 'Completed',
  canceled: 'Canceled',
  chooseCourier: 'Choose courier',
  chooseDriver: 'Choose Driver',
  loadType: 'Load type',
  templateType: 'Template type',
  origin: 'Origin',
  destination: 'Destination',
  multiDestination: 'Multi destination',
  payableAmount: 'Payable amount',
  cancelRequest: 'Cancel',
  reOrderRegistration: 'Re-order registration',
  submitFeedback: 'Submit feedback',
  editFeedback: 'Edit feedback',
  useTemplate: 'Use template',
  addNewTemplate: 'Add new template',
  createTemplate: 'Create template',
  driverLiveLocation: 'Driver live location',
  notPriced: 'Not priced',
  generalInfo: 'General info',
  loadTime: 'Load time',
  loadTimeHour: 'Load time',
  dischargeTime: 'Discharge time',
  estimatedTimeFromOriginToDestination:
    'Estimated time from origin to destination',
  distanceFromOriginToDestination: 'Distance from origin to destination',
  driverOfferAmount: 'Driver offer amount',
  driverName: 'Driver name',
  driverLastName: 'Driver last name',
  driverNationalId: 'Driver national ID',
  smartFleetCode: 'Smart fleet code',
  plate: 'Plate',
  originAndDestinationInfo: 'Origin and destination info',
  deliverer: 'Deliverer',
  transferee: 'Transferee',
  floor: 'Floor',
  unit: 'Unit',
  distanceFromDoorToCar: 'Distance from door to car',
  destination1: 'First destination',
  destination2: 'Second destination',
  destination3: 'Third destination',
  destination4: 'Forth destination',
  finalDestination: 'Final destination',
  trackingCodeOfCourier: 'Tracking code of {courier}',
  orderTracking: 'Order tracking',
  carType: 'Car type',
  loaderType: 'Loader type',
  numberOfWorkers: 'Number of workers',
  trajectory: 'Trajectory',
  noAllocation: 'No allocation',
  loadSpecifications: 'Load specifications',
  packageType: 'Package type',
  weight: 'Weight',
  loadMonetaryValue: 'Load monetary value',
  monetaryValue: 'Monetary value',
  technicalForce: 'Technical force',
  costlyItems: 'Costly items',
  stop: 'Stop',
  returnToOrigin: 'Return to origin',
  postalPostageSpecifications: 'Postal postage specifications',
  collectionTime: 'Collection time',
  totalAmount: 'Total amount',
  discount: 'Discount',
  templateTitle: 'Template title',
  continueOrderRegistration: 'Continue order registration',
  movingDate: 'Moving date',
  movingTime: 'Moving time',
  loadDate: 'Load date',
  dischargeDate: 'Discharge date',
  loadTemplate: 'Load template',
  loadDraft: 'Load draft',
  middlePoints: {
    1: 'First destination',
    2: 'Second destination',
    3: 'Third destination',
    4: 'Fourth destination',
    5: 'Fifth destination'
  },
  completeAddress: 'Complete address',
  freightElevator: 'Freight elevator',
  withCar: 'With car',
  withoutCar: 'Without car',
  theSelectedCarWasRemoved: 'The selected car was removed',
  removeSimpleEmployeeForChangeState:
    "To change {orderType}'s type, please remove selected simple employee(s) from your list.",
  removeCarsForChangeState:
    "To change {orderType}'s type, please remove selected car(s) from your list.",
  removePackagesForChangeState:
    "To change {orderType}'s type, please remove selected package(s) from your list.",
  timing: 'Timing',
  carLaborerCount: '{number} {carTitle} laborer count',
  cargoWorker: 'Cargo worker',
  intercityCarSelectionDescription:
    'Cargo workers in destination city is on load owner',
  sortBy: 'Sort by',
  sortOptions: {
    popular: 'Popular',
    name: 'Name',
    cheapest: 'Cheapest',
    mostExpensive: 'Most expensive',
    nearest: 'Nearest'
  },
  distance: 'Distance',
  courierProfile: 'Courier profile',
  offerSelectionError: {
    singleSelect: 'Select one courier to continue',
    multiSelect: 'Select at least one courier to continue'
  },
  completeInformation: 'Complete information',
  saveAsDraft: 'Save as draft',
  editLoadTemplate: 'Edit load template',
  submitLoadTemplate: 'Submit load template',
  submitAndPay: 'Submit and pay',
  submitRequest: 'Submit request',
  createOrderWarning:
    'Are you sure to submit this order?\nEditing is not possible after order submit.',
  tariffBasedLoadSuccessDescription:
    'Your order submitted successfully, confirm message will send as soon as any courier accept your order.',
  notTariffBasedLoadSuccessDescription:
    'Your order submitted successfully, notification message will send as soon as any courier pricing your order',
  viewSubmittedLoads: 'View submitted loads',
  submitNewLoadRequest: 'Submit new load request',
  busyCities: 'Busy cities',
  selectPointOnMap: 'Select {point} on map',
  more: 'More ...',
  rangeMessage: {
    100: 'This request calculated with <b>urban</b> tariffs',
    200: 'This request calculated  with <b>intercity</b> tariffs and laws'
  },
  pleaseSelectPointOnMap: 'Please select {item} on map',
  loadWeight: 'Load weight',
  typeOfShippingDocument: 'Type of shipping document',
  postageSpecification: 'Postage specification',
  postage: 'Postage',
  addPostage: 'Add postage',
  selectCollectionTImeToContinue: 'Select collection time to continue',
  loadId: 'Load ID',
  specification: 'Specification',
  newLoadTemplateCreatedSuccessfully: 'New load template created successfully',
  loadTemplateEditedSuccessfully: 'Load template edited successfully',
  areYouSureYouWantToDraftThisOrder:
    'Are you sure you want to save this order as draft?',
  draftCreatedSuccessfully: 'Draft created successfully',
  selectDriverInfo: 'Select driver info',
  selectVehicleInfo: 'Select vehicle info',
  selectLocation: 'Select location',
  propertySelection: 'Property selection',
  offerSelection: 'Offer selection (courier)',
  overview: 'Overview',
  successfulSubmit: 'Successful submit',
  orderCancelReason: 'Order cancel reason',
  orderCanceledSuccessfully: 'Order canceled successfully',
  courierSelectedSuccessfullyForThisOrder:
    '{courier} is successfully selected for this order as courier',
  driverSelectedSuccessfullyForThisOrder:
    '{driver} is successfully selected for this order as driver',
  selectCity: 'Select city',
  citySelectorDescription_html:
    'Please select one of cities below as <span class="font-bold">{title}</span>',
  submitAndNextStep: 'Submit and next',
  temporaryLoadSuccessMessage:
    'Your order submitted successfully, confirm message will send as soon as driver accept your order.',
  reserveOrderForLater: 'Reserve order for the future',
  reserveDate: 'Reserve date',
  reserveTime: 'Reserve time',
  doYouWantToSaveUncompletedOrderToDrafts:
    'Do you want to save uncompleted order to drafts?',
  orderPresubmitedInSystemAndSubmitWhenPaymentIsDone:
    'Order pre-submited in Badpa and submit in {thirdParty} whem payment is done.',
  orderStatus: 'Order status',
  moveToMiddlePoint: 'Move to {middlePoint}',
  paid: 'Paid',
  notPaid: 'Not paid',
  addDestination: 'Add destination',
  viewOnMap: 'View on map',
  deliveryCode: 'Delivery code',
  dateOfCollection: 'Date of collection',
  timeOfCollection: 'Time of collection',
  gatheringLocation: 'Gathering location',
  dischargeLocation: 'Discharge location',
  carExcluded: 'No vehicle',
  insuranceExcessPercent: 'Insurance excess percent',
  manualExcessPercent: 'Manual excess percent',
  excelFileInfo: 'Excel file info',
  grouping: 'Grouping',
  groupingDescription:
    'Select the type of vehicle and driver for the new submission group.',
  submitLoads: 'Submit loads',
  loads: 'Loads',
  allLoadDatesInGroupShouldBeInSameDay:
    'All load dates in group should be in same day',
  allLoadTypesInGroupShouldBeTheSame:
    'All load types in group should be the same',
  allPackageTypesInGroupShouldBeTheSame:
    'All package types in group should be the same',
  dischargeStartTime: 'Discharge start time',
  dischargeEndTime: 'Discharge end time',
  dischargeEndTimeShouldBeAtLeastOneHourAfterStartTime:
    'Discharge end time should be at least one hour after start time',
  loadingStartTime: 'Loading start time',
  loadingEndTime: 'Loading end time',
  addon: 'Addon',
  batchId: 'Batch ID',
  destinations: {
    1: 'First destination',
    2: 'Second destination',
    3: 'Third destination',
    4: 'Fourth destination',
    5: 'Fifth destination',
    6: 'Sixth destination',
    7: 'Seventh destination',
    8: 'Eighth destination',
    9: 'Ninth destination',
    10: 'Tenth destination'
  },
  licenseIsRequired: 'License is required',
  licenses: 'Licenses',
  IWantInsurance: 'I want insurance',
  fromStartToEnd: 'from {start} to {end}',
  nameOfThePayee: 'Name of the payee'
}
